import { BooleanField, Datagrid, DateField, Filter, List, TextField, TextInput } from 'react-admin'

const UserFilter = (props) => (
  <Filter {...props}>
    <TextInput label='pos.search' source='email' alwaysOn />
  </Filter>
)

const UserList = (props) => (
  <List filters={<UserFilter />} sort={{ field: 'email', order: 'ASC' }} {...props}>
    <Datagrid rowClick='edit' bulkActionButtons={false}>
      <TextField source='displayName' label='resources.users.fields.username' />
      <TextField source='email' label='resources.users.fields.email' />
      <TextField source='defaultRole' label='resources.users.fields.role' />
      <BooleanField source='disabled' label='resources.users.fields.disabled' />
      <DateField source='lastSeen' showTime label='resources.users.fields.last_seen' />
    </Datagrid>
  </List>
)

export default UserList
